module.exports = __webpack_public_path__ + "static/media/E-SCOOTER.55d92b6c.png";